import {remCalc} from '_themeUtils'

const productRelatedSelector = {
    ProductRelatedSelector: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                alignItems: 'flex-start',
                gap: {base: 'spacing.4', md: 'spacing.5'},
                py: {base: 'spacing.4', md: 0},
            },
            title: {
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            productsContainer: {
                w: '100%',
                alignItems: 'flex-start',
                overflowX: 'auto',
            },

            productWrapper: {
                width: 'fit-content',
                flexShrink: 0,
                flexBasis: {base: 'calc(25% - 6px)', md: 'auto'},
            },

            productImageWrapper: {
                position: 'relative',
                height: {base: 'auto', md: remCalc(130)},
                aspectRatio: {base: 78 / 99, md: 86 / 110},
                overflow: 'hidden',
            },

            productImageWrapperSelected: {
                border: '1px solid black',
            },

            productDescription: {
                textAlign: 'center',
                textStyle: 'paragraphXs',
                fontWeight: 'normal',
                pt: 'spacing.1',
                width: '100%',
            },

            titleSkeleton: {
                w: '35%',
                h: remCalc(17),
            },

            productImageSkeleton: {
                w: '100%',
                h: '100%',
            },

            productDescriptionSkeleton: {
                w: '50%',
                h: remCalc(10),
                margin: 'auto',
                mt: 'spacing.1.5',
            },
        }),
    },
}

export default productRelatedSelector
